import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { Dispatch    }  from 'redux';
import { useDispatch }  from 'react-redux';

import { useTypedSelector }  from '../../../datas/useTypeSelector';

import { postEvent } from '../../../network/api_events_stats';

interface RedirectWithImageProps {
  baseUrl: string;
  delay: number; // délai en millisecondes
  imageSrc: string;
}

// Tableau de correspondance code -> chemin
// TODO: À terme, ce tableau sera lu depuis une base de données
// const REDIRECT_CODES: Record<string, string> = {
  // "OpNikonZR": "camera-nikon-zr-nue-nikvoa180ae-152051.html",
  //Ajoutez vos codes ici
// };

const RedirectWithImage: React.FC<RedirectWithImageProps> = ({
  baseUrl = '',
  delay = 3000,
  imageSrc = ''
}) => {
	
  const navigate  = useNavigate();
  const dispatch: Dispatch<any> = useDispatch();

  const { authentication }        = useTypedSelector((state) => state.authenticationManagment );
  const { user           } = useTypedSelector ((state) => state.userManagment );	
	
  const [countdown, setCountdown] = useState(Math.ceil(delay / 1000));
  
  
  
  /*
  // Récupérer le paramètre redirect de l'URL
  const getRedirectParam = () => {
    const params = new URLSearchParams(window.location.search);
    return params.get('redirect');
  };
  
  const redirectParam = getRedirectParam();
  */

  const [searchParams] = useSearchParams();
  const redirectParam = searchParams.get('redirect');
  
  // Résoudre le chemin : si c'est un code connu, utiliser le mapping, sinon utiliser tel quel
  const redirectPath = redirectParam  
    // ? (REDIRECT_CODES[redirectParam] || redirectParam)
    // : null;
  
  console.log ( "redirectParam : ", redirectParam)
  console.log ( "redirectPath  : ", redirectPath)
  
  // Déterminer si c'est un code ou un chemin direct
  //const isCode = redirectParam && REDIRECT_CODES.hasOwnProperty(redirectParam);
  
 useEffect(() => {
  if (!redirectPath) return;

  const fullUrl = `${baseUrl}${redirectPath}`;

  // Enregistrer l'événement
  const eventMessage = fullUrl;
  postEvent(
    "__REDIRECT__:" +
      window.location.pathname +
      window.location.search +
      window.location.hash +
      ":" +
      eventMessage,
    authentication.login
  );

  console.log("postEvent  : ", eventMessage);

  // Compte à rebours
  const countdownInterval = setInterval(() => {
    setCountdown((prev) => {
      if (prev <= 1) {
        clearInterval(countdownInterval);
        return 0;
      }
      return prev - 1;
    });
  }, 1000);

  // Timer de redirection
  const redirectTimer = setTimeout(() => {
    window.location.href = fullUrl;
  }, delay);

  return () => {
    clearTimeout(redirectTimer);
    clearInterval(countdownInterval);
  };
}, [redirectPath, baseUrl, delay, authentication.login]);

  
  if (!redirectParam) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-100">
        <div className="bg-white p-8 rounded-lg shadow-lg max-w-md text-center">
          <div className="text-red-500 mb-4">
            <svg className="w-16 h-16 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
            </svg>
          </div>
          <h2 className="text-2xl font-bold text-gray-800 mb-2">Paramètre manquant</h2>
          <p className="text-gray-600">
            Veuillez fournir un paramètre <code className="bg-gray-200 px-2 py-1 rounded">?redirect=/votre-chemin</code> ou <code className="bg-gray-200 px-2 py-1 rounded">?redirect=code</code> dans l'URL.
          </p>
        </div>
      </div>
    );
  }
  
  return (
    <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-indigo-500 to-purple-600">
      <div className="bg-white p-8 rounded-2xl shadow-2xl max-w-lg text-center">
        
		<div className="mb-6">
          <img
            src={imageSrc}
            alt="Redirection en cours"
            className="max-w-full h-auto rounded-lg mx-auto"
          />
        </div>
        
        <div className="space-y-4">
          <h2 className="text-2xl font-bold text-gray-800">
            Redirection en cours chez notre partenaire...
          </h2>
          
          <div className="flex items-center justify-center space-x-2">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-indigo-600"></div>
            <span className="text-4xl font-bold text-indigo-600">{countdown}</span>
          </div>
          
          <p className="text-gray-600">
            Vous allez être redirigé vers<br />
            <code className="text-sm bg-gray-100 px-3 py-1 rounded mt-2 inline-block break-all">
              {baseUrl}{redirectPath}
            </code>
          </p>
          
          <a
            href={`${baseUrl}${redirectPath}`}
            className="inline-block mt-4 text-indigo-600 hover:text-indigo-800 underline"
          >
            Cliquez ici si vous n'êtes pas redirigé automatiquement
          </a>
        </div>
      </div>
    </div>
  );
};

export default RedirectWithImage;